import {Vue} from 'ui.vue';
import BasicInput from '../../../common/basic-input/src/basic-input';
import '../../authorization.sass';
import Modal from '../../../common/modal/src/modal';

Vue.component('login-form', {

    data() {
        return {
            removalModal: false,
        }
    },
	template: `
		<div class="login">
			<div class="login__wrapper">
				<div class="login__left-side">
					<a class="login__logo-link" href="/">
						<img class="login__logo" src="/sources/img/logo-white.svg" alt="logo">
					</a>
					<h3 class="login__form-title desktop">С возвращением!</h3>
					<p class="login__form-description desktop">Новые заказы и клиенты уже ждут</p>
					<img class="login__desktop-image" src="/sources/img/login-desktop.png" alt="logo">
				</div>
				<div class="login__form-wrapper">
					<a class="login__logo login__logo--mobile" href="/">
						<img src="/sources/img/logo-white.svg" alt="logo">
					</a>
					<div class="login__form-text-wrapper">
						<h3 class="login__form-type desktop">Вход</h3>
						<h3 class="login__form-title mobile">С возвращением!</h3>
						<p class="login__form-description login__form-description--login mobile">Новые заказы и клиенты уже&nbsp;ждут</p>
					</div>

					<form class="login__form" action="/lk/" method="post">
						<h3 class="login__form-type mobile">Вход</h3>
						<input name="backurl" type="text" value="/lk/" hidden>
						<input name="AUTH_FORM" value="Y" type="text" hidden>
						<input name="TYPE" value="AUTH" type="text" hidden>
						<input name="Login" value="Войти" type="text" hidden>
						<BasicInput name="USER_LOGIN" title="E-mail*"/>
						<BasicInput name="USER_PASSWORD" title="Пароль*" type="password"/>

						<input class="checkbox-input" type="checkbox" value="Y" id="remember" name="USER_REMEMBER">
						<label class="checkbox-label" for="remember">Запомнить меня</label>

						<div class="login__form-buttons">
							<button class="login__form-button" type="submit">Войти</button>
							<a href="/lk/forget.php" class="login__form-link">Забыли пароль?</a>
						</div>
					</form>
					<div v-if="!TECE.DISABLE_REGISTER" class="login__additional-links">
						<span class="login__additional-text">Нет учетной записи?</span>
						<a href="/lk/registration.php" class="login__additional-link">Зарегистрироваться</a>
					</div>
					<div v-if="TECE.DISABLE_REGISTER" class="login__additional-links">
                        <span class="login__additional-text">Нет учетной записи?</span>
                        <a @click="removalModal = true" class="link removal">Зарегистрироваться</a>
                    </div>
                    <Modal v-if="removalModal" class="removal" @close="removalModal = false" type="notification">
                        <template v-slot:body>
                            <p class="modal-header" style="text-align:center;">Регистрация новых участников временно недоступна.
                            Приносим извинения за доставленные неудобства.</p>
                            <div class="btn-wrapper">
                                <a @click="removalModal = false" class="link">Закрыть</a>
                            </div>
                        </template>
                    </Modal>

				</div>
			</div>
		</div>
	`,

	components: {
		BasicInput: BasicInput,
		Modal: Modal,
	}
});

Vue.create({
	el: 'LoginForm',
	template: '<login-form/>'
});
